import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type InstantRoomBlockMonetaryValueFieldsFragment = {
  __typename?: 'TravelReservationMonetaryValue';
  valueInMinorUnits: number;
  currency: Types.TravelCurrencyCode;
  digits: number;
};

export type InstantRoomBlockRoomFieldsFragment = {
  __typename?: 'InstantRoomBlockRoom';
  id: string;
  state: Types.InstantRoomBlockRoomStateDtoEnum;
  joyReferenceCode: string;
  hotelConfirmationCode?: string | null;
  roomTypeName?: string | null;
  guestFirstName?: string | null;
  guestLastName?: string | null;
  guestEmail?: string | null;
  guestPhone?: string | null;
  claimedAt?: string | null;
  renameState?: Types.InstantRoomBlockRenameStateDtoEnum | null;
  nightlyRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
  totalWithTaxes: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
  taxesAndFees: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
  onsiteCharges: Array<{
    __typename?: 'TravelOfferReservationOnsiteCharge';
    title: string;
    units?: Array<string> | null;
    unitPrice: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
  }>;
};

export type InstantRoomBlockSummaryFieldsFragment = {
  __typename?: 'InstantRoomBlock';
  id: string;
  eventId: string;
  status: Types.InstantRoomBlockStatusDtoEnum;
  joyPlaceId: string;
  hotelName?: string | null;
  checkInDate: string;
  checkOutDate: string;
  nights: number;
  roomCount: number;
  requestedRoomCount: number;
  claimedCount: number;
  releasedCount: number;
  bookByDate: string;
  releaseDate: string;
  partialAcceptanceDeadline?: string | null;
};

export type InstantRoomBlockFieldsFragment = {
  __typename?: 'InstantRoomBlock';
  id: string;
  eventId: string;
  status: Types.InstantRoomBlockStatusDtoEnum;
  joyPlaceId: string;
  hotelName?: string | null;
  checkInDate: string;
  checkOutDate: string;
  nights: number;
  roomCount: number;
  requestedRoomCount: number;
  claimedCount: number;
  releasedCount: number;
  bookByDate: string;
  releaseDate: string;
  partialAcceptanceDeadline?: string | null;
  rooms: Array<{
    __typename?: 'InstantRoomBlockRoom';
    id: string;
    state: Types.InstantRoomBlockRoomStateDtoEnum;
    joyReferenceCode: string;
    hotelConfirmationCode?: string | null;
    roomTypeName?: string | null;
    guestFirstName?: string | null;
    guestLastName?: string | null;
    guestEmail?: string | null;
    guestPhone?: string | null;
    claimedAt?: string | null;
    renameState?: Types.InstantRoomBlockRenameStateDtoEnum | null;
    nightlyRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
    totalWithTaxes: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
    taxesAndFees: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
    onsiteCharges: Array<{
      __typename?: 'TravelOfferReservationOnsiteCharge';
      title: string;
      units?: Array<string> | null;
      unitPrice: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
    }>;
  }>;
};

export type InstantRoomBlockAllowanceQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type InstantRoomBlockAllowanceQuery = {
  __typename?: 'Query';
  instantRoomBlockAllowance: {
    __typename?: 'InstantRoomBlockAllowance';
    minRooms: number;
    maxRooms: number;
    isFeatureEnabled: boolean;
    blocksRemaining?: number | null;
    remaining?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number } | null;
    hardCapRemaining?: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number } | null;
  };
};

export type InstantRoomBlockByIdQueryVariables = Types.Exact<{
  instantRoomBlockId: Types.Scalars['ID'];
}>;

export type InstantRoomBlockByIdQuery = {
  __typename?: 'Query';
  instantRoomBlock?: {
    __typename?: 'InstantRoomBlock';
    id: string;
    eventId: string;
    status: Types.InstantRoomBlockStatusDtoEnum;
    joyPlaceId: string;
    hotelName?: string | null;
    checkInDate: string;
    checkOutDate: string;
    nights: number;
    roomCount: number;
    requestedRoomCount: number;
    claimedCount: number;
    releasedCount: number;
    bookByDate: string;
    releaseDate: string;
    partialAcceptanceDeadline?: string | null;
    rooms: Array<{
      __typename?: 'InstantRoomBlockRoom';
      id: string;
      state: Types.InstantRoomBlockRoomStateDtoEnum;
      joyReferenceCode: string;
      hotelConfirmationCode?: string | null;
      roomTypeName?: string | null;
      guestFirstName?: string | null;
      guestLastName?: string | null;
      guestEmail?: string | null;
      guestPhone?: string | null;
      claimedAt?: string | null;
      renameState?: Types.InstantRoomBlockRenameStateDtoEnum | null;
      nightlyRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
      totalWithTaxes: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
      taxesAndFees: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
      onsiteCharges: Array<{
        __typename?: 'TravelOfferReservationOnsiteCharge';
        title: string;
        units?: Array<string> | null;
        unitPrice: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
      }>;
    }>;
  } | null;
};

export type InstantRoomBlocksForEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type InstantRoomBlocksForEventQuery = {
  __typename?: 'Query';
  instantRoomBlocksForEvent: Array<{
    __typename?: 'InstantRoomBlock';
    id: string;
    eventId: string;
    status: Types.InstantRoomBlockStatusDtoEnum;
    joyPlaceId: string;
    hotelName?: string | null;
    checkInDate: string;
    checkOutDate: string;
    nights: number;
    roomCount: number;
    requestedRoomCount: number;
    claimedCount: number;
    releasedCount: number;
    bookByDate: string;
    releaseDate: string;
    partialAcceptanceDeadline?: string | null;
  }>;
};

export type InstantRoomBlockAcceptPartialMutationVariables = Types.Exact<{
  payload: Types.InstantRoomBlockAcceptPartialPayload;
}>;

export type InstantRoomBlockAcceptPartialMutation = {
  __typename?: 'Mutation';
  instantRoomBlockAcceptPartial: {
    __typename?: 'InstantRoomBlockCreateResult';
    instantRoomBlock?: {
      __typename?: 'InstantRoomBlock';
      id: string;
      eventId: string;
      status: Types.InstantRoomBlockStatusDtoEnum;
      joyPlaceId: string;
      hotelName?: string | null;
      checkInDate: string;
      checkOutDate: string;
      nights: number;
      roomCount: number;
      requestedRoomCount: number;
      claimedCount: number;
      releasedCount: number;
      bookByDate: string;
      releaseDate: string;
      partialAcceptanceDeadline?: string | null;
      rooms: Array<{
        __typename?: 'InstantRoomBlockRoom';
        id: string;
        state: Types.InstantRoomBlockRoomStateDtoEnum;
        joyReferenceCode: string;
        hotelConfirmationCode?: string | null;
        roomTypeName?: string | null;
        guestFirstName?: string | null;
        guestLastName?: string | null;
        guestEmail?: string | null;
        guestPhone?: string | null;
        claimedAt?: string | null;
        renameState?: Types.InstantRoomBlockRenameStateDtoEnum | null;
        nightlyRate: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
        totalWithTaxes: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
        taxesAndFees: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
        onsiteCharges: Array<{
          __typename?: 'TravelOfferReservationOnsiteCharge';
          title: string;
          units?: Array<string> | null;
          unitPrice: { __typename?: 'TravelReservationMonetaryValue'; valueInMinorUnits: number; currency: Types.TravelCurrencyCode; digits: number };
        }>;
      }>;
    } | null;
  };
};

export type InstantRoomBlockCancelMutationVariables = Types.Exact<{
  payload: Types.InstantRoomBlockCancelPayload;
}>;

export type InstantRoomBlockCancelMutation = {
  __typename?: 'Mutation';
  instantRoomBlockCancel: { __typename?: 'InstantRoomBlockCancelResult'; releasedRoomCount: number; retainedClaimedRoomCount: number };
};

export const InstantRoomBlockSummaryFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedRoomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releasedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bookByDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partialAcceptanceDeadline' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InstantRoomBlockMonetaryValueFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelReservationMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InstantRoomBlockRoomFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockRoomFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlockRoom' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyRate' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalWithTaxes' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxesAndFees' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onsiteCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unitPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'joyReferenceCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelConfirmationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomTypeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renameState' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelReservationMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InstantRoomBlockFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockRoomFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelReservationMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockRoomFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlockRoom' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyRate' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalWithTaxes' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxesAndFees' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onsiteCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unitPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'joyReferenceCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelConfirmationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomTypeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renameState' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedRoomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releasedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bookByDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partialAcceptanceDeadline' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InstantRoomBlockAllowanceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstantRoomBlockAllowance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantRoomBlockAllowance' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'minRooms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxRooms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFeatureEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blocksRemaining' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'remaining' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hardCapRemaining' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelReservationMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInstantRoomBlockAllowanceQuery__
 *
 * To run a query within a React component, call `useInstantRoomBlockAllowanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstantRoomBlockAllowanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstantRoomBlockAllowanceQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useInstantRoomBlockAllowanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstantRoomBlockAllowanceQuery, InstantRoomBlockAllowanceQueryVariables>) {
  return ApolloReactHooks.useQuery<InstantRoomBlockAllowanceQuery, InstantRoomBlockAllowanceQueryVariables>(InstantRoomBlockAllowanceDocument, baseOptions);
}
export function useInstantRoomBlockAllowanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstantRoomBlockAllowanceQuery, InstantRoomBlockAllowanceQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<InstantRoomBlockAllowanceQuery, InstantRoomBlockAllowanceQueryVariables>(InstantRoomBlockAllowanceDocument, baseOptions);
}
export type InstantRoomBlockAllowanceQueryHookResult = ReturnType<typeof useInstantRoomBlockAllowanceQuery>;
export type InstantRoomBlockAllowanceLazyQueryHookResult = ReturnType<typeof useInstantRoomBlockAllowanceLazyQuery>;
export type InstantRoomBlockAllowanceQueryResult = Apollo.QueryResult<InstantRoomBlockAllowanceQuery, InstantRoomBlockAllowanceQueryVariables>;
export const InstantRoomBlockByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstantRoomBlockById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instantRoomBlockId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantRoomBlock' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'instantRoomBlockId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'instantRoomBlockId' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelReservationMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockRoomFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlockRoom' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyRate' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalWithTaxes' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxesAndFees' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onsiteCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unitPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'joyReferenceCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelConfirmationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomTypeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renameState' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedRoomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releasedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bookByDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partialAcceptanceDeadline' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockRoomFields' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInstantRoomBlockByIdQuery__
 *
 * To run a query within a React component, call `useInstantRoomBlockByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstantRoomBlockByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstantRoomBlockByIdQuery({
 *   variables: {
 *      instantRoomBlockId: // value for 'instantRoomBlockId'
 *   },
 * });
 */
export function useInstantRoomBlockByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstantRoomBlockByIdQuery, InstantRoomBlockByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<InstantRoomBlockByIdQuery, InstantRoomBlockByIdQueryVariables>(InstantRoomBlockByIdDocument, baseOptions);
}
export function useInstantRoomBlockByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstantRoomBlockByIdQuery, InstantRoomBlockByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<InstantRoomBlockByIdQuery, InstantRoomBlockByIdQueryVariables>(InstantRoomBlockByIdDocument, baseOptions);
}
export type InstantRoomBlockByIdQueryHookResult = ReturnType<typeof useInstantRoomBlockByIdQuery>;
export type InstantRoomBlockByIdLazyQueryHookResult = ReturnType<typeof useInstantRoomBlockByIdLazyQuery>;
export type InstantRoomBlockByIdQueryResult = Apollo.QueryResult<InstantRoomBlockByIdQuery, InstantRoomBlockByIdQueryVariables>;
export const InstantRoomBlocksForEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InstantRoomBlocksForEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantRoomBlocksForEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedRoomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releasedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bookByDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partialAcceptanceDeadline' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInstantRoomBlocksForEventQuery__
 *
 * To run a query within a React component, call `useInstantRoomBlocksForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstantRoomBlocksForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstantRoomBlocksForEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useInstantRoomBlocksForEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InstantRoomBlocksForEventQuery, InstantRoomBlocksForEventQueryVariables>) {
  return ApolloReactHooks.useQuery<InstantRoomBlocksForEventQuery, InstantRoomBlocksForEventQueryVariables>(InstantRoomBlocksForEventDocument, baseOptions);
}
export function useInstantRoomBlocksForEventLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InstantRoomBlocksForEventQuery, InstantRoomBlocksForEventQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<InstantRoomBlocksForEventQuery, InstantRoomBlocksForEventQueryVariables>(InstantRoomBlocksForEventDocument, baseOptions);
}
export type InstantRoomBlocksForEventQueryHookResult = ReturnType<typeof useInstantRoomBlocksForEventQuery>;
export type InstantRoomBlocksForEventLazyQueryHookResult = ReturnType<typeof useInstantRoomBlocksForEventLazyQuery>;
export type InstantRoomBlocksForEventQueryResult = Apollo.QueryResult<InstantRoomBlocksForEventQuery, InstantRoomBlocksForEventQueryVariables>;
export const InstantRoomBlockAcceptPartialDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InstantRoomBlockAcceptPartial' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlockAcceptPartialPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantRoomBlockAcceptPartial' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instantRoomBlock' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelReservationMonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockRoomFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlockRoom' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyRate' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalWithTaxes' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxesAndFees' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onsiteCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unitPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockMonetaryValueFields' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'joyReferenceCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelConfirmationCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomTypeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renameState' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hotelName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedRoomCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releasedCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bookByDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'releaseDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partialAcceptanceDeadline' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InstantRoomBlockFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlock' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockSummaryFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooms' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'InstantRoomBlockRoomFields' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InstantRoomBlockAcceptPartialMutationFn = Apollo.MutationFunction<InstantRoomBlockAcceptPartialMutation, InstantRoomBlockAcceptPartialMutationVariables>;

/**
 * __useInstantRoomBlockAcceptPartialMutation__
 *
 * To run a mutation, you first call `useInstantRoomBlockAcceptPartialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstantRoomBlockAcceptPartialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantRoomBlockAcceptPartialMutation, { data, loading, error }] = useInstantRoomBlockAcceptPartialMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useInstantRoomBlockAcceptPartialMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<InstantRoomBlockAcceptPartialMutation, InstantRoomBlockAcceptPartialMutationVariables>,
) {
  return ApolloReactHooks.useMutation<InstantRoomBlockAcceptPartialMutation, InstantRoomBlockAcceptPartialMutationVariables>(InstantRoomBlockAcceptPartialDocument, baseOptions);
}
export type InstantRoomBlockAcceptPartialMutationHookResult = ReturnType<typeof useInstantRoomBlockAcceptPartialMutation>;
export type InstantRoomBlockAcceptPartialMutationResult = Apollo.MutationResult<InstantRoomBlockAcceptPartialMutation>;
export type InstantRoomBlockAcceptPartialMutationOptions = Apollo.BaseMutationOptions<InstantRoomBlockAcceptPartialMutation, InstantRoomBlockAcceptPartialMutationVariables>;
export const InstantRoomBlockCancelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InstantRoomBlockCancel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'InstantRoomBlockCancelPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantRoomBlockCancel' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'releasedRoomCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retainedClaimedRoomCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type InstantRoomBlockCancelMutationFn = Apollo.MutationFunction<InstantRoomBlockCancelMutation, InstantRoomBlockCancelMutationVariables>;

/**
 * __useInstantRoomBlockCancelMutation__
 *
 * To run a mutation, you first call `useInstantRoomBlockCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstantRoomBlockCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instantRoomBlockCancelMutation, { data, loading, error }] = useInstantRoomBlockCancelMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useInstantRoomBlockCancelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InstantRoomBlockCancelMutation, InstantRoomBlockCancelMutationVariables>) {
  return ApolloReactHooks.useMutation<InstantRoomBlockCancelMutation, InstantRoomBlockCancelMutationVariables>(InstantRoomBlockCancelDocument, baseOptions);
}
export type InstantRoomBlockCancelMutationHookResult = ReturnType<typeof useInstantRoomBlockCancelMutation>;
export type InstantRoomBlockCancelMutationResult = Apollo.MutationResult<InstantRoomBlockCancelMutation>;
export type InstantRoomBlockCancelMutationOptions = Apollo.BaseMutationOptions<InstantRoomBlockCancelMutation, InstantRoomBlockCancelMutationVariables>;
